export var FILE_EXTENSIONS = {
  CSV: 'csv',
  EXCEL: 'xls',
  PDF: 'pdf'
};
export var FILE_DOWNLOAD_ACTIONS = {
  EXPORT_AS_CSV: 'EXPORT_AS_CSV',
  EXPORT_AS_XLS: 'EXPORT_AS_XLS'
};